export interface MenuOption {
  value: string;
  label: string;
}

export const MARCA_PRODOTTO_OPTIONS: MenuOption[] = [
  { value: '', label: '' },
  { value: 'Promat', label: 'Promat' },
  { value: 'AF Systems', label: 'AF Systems' },
  { value: 'Global Building', label: 'Global Building' },
  { value: 'Hilti', label: 'Hilti' },
];
